import { servicePricingService } from '../../../services/ServicePricing'
import {
  IServicePricingCreateDTO,
  IServicePricingModel,
  IServicePricingUpdateDTO
} from '../../../types/service-pricing'
import {
  SERVICE_PRICING_REQUEST,
  SERVICE_PRICING_REQUEST_FAIL,
  SERVICE_PRICING_REQUEST_SUCCESS,
  SERVICE_PRICING_UPDATE,
  SERVICE_PRICING_UPDATE_FAIL,
  SERVICE_PRICING_UPDATE_SUCCESS
} from '../../constants'
import { actionCreators as serviceActionCreators } from './index'

export interface IServicePricingAction {
  type: string
}

export interface IServicePricingRequest extends IServicePricingAction {}

export interface IServicePricingRequestSuccess extends IServicePricingAction {
  data: IServicePricingModel | null
}

export interface IServicePricingRequestFail extends IServicePricingAction {
  error: string
}

export interface IServicePricingUpdate extends IServicePricingAction {}

export interface IServicePricingUpdateSuccess extends IServicePricingAction {
  data: IServicePricingModel
}

export interface IServicePricingUpdateFail extends IServicePricingAction {
  error: string
}

export function fetchServicePricingItem(serviceId: string, orgId: string) {
  return (dispatch: any) => {
    dispatch(servicePricingItemSetFetching())
    return servicePricingService
      .fetchPricing(serviceId, orgId)
      .then((result: IServicePricingModel | null) => {
        dispatch(servicePricingItemSetFetchSuccess(result))
      })
      .catch((error: string) => {
        dispatch(servicePricingItemSetFetchFail(error))
      })
  }
}

export function createServicePricingItem(pricing: IServicePricingCreateDTO) {
  return async (dispatch: any) => {
    dispatch(servicePricingItemSetUpdating())
    return servicePricingService
      .createPricing(pricing)
      .then(pricing => {
        dispatch(servicePricingItemSetUpdateSuccess(pricing))
        dispatch(serviceActionCreators.serviceCreateSetStepCompleted(4, true))
        return
      })
      .catch(error => {
        dispatch(servicePricingItemSetUpdateFail(error))
        return error
      })
  }
}

export function updateServicePricingItem(pricing: IServicePricingUpdateDTO) {
  return async (dispatch: any) => {
    dispatch(servicePricingItemSetUpdating())
    return servicePricingService
      .updatePricing(pricing)
      .then(pricing => {
        dispatch(servicePricingItemSetUpdateSuccess(pricing))
        dispatch(serviceActionCreators.serviceCreateSetStepCompleted(4, true))
        return
      })
      .catch(error => {
        dispatch(servicePricingItemSetUpdateFail(error))
        return error
      })
  }
}

export function servicePricingItemSetFetching(): IServicePricingRequest {
  return {
    type: SERVICE_PRICING_REQUEST
  }
}

export function servicePricingItemSetFetchSuccess(data: IServicePricingModel | null): IServicePricingRequestSuccess {
  return {
    type: SERVICE_PRICING_REQUEST_SUCCESS,
    data
  }
}

export function servicePricingItemSetFetchFail(error: string): IServicePricingRequestFail {
  return {
    type: SERVICE_PRICING_REQUEST_FAIL,
    error
  }
}

export function servicePricingItemSetUpdating(): IServicePricingUpdate {
  return {
    type: SERVICE_PRICING_UPDATE
  }
}

export function servicePricingItemSetUpdateSuccess(data: IServicePricingModel): IServicePricingUpdateSuccess {
  return {
    type: SERVICE_PRICING_UPDATE_SUCCESS,
    data
  }
}

export function servicePricingItemSetUpdateFail(error: string): IServicePricingUpdateFail {
  return {
    type: SERVICE_PRICING_UPDATE_FAIL,
    error
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/services/servicePricing.ts